/* @flow */

import * as React from 'react'
import styled from 'styled-components'

import { WidgetContainer } from '../shared'

const WebshopTextWidget = ({ gridItem }) => {
  return (
    <Container gridItem={gridItem}>
      <div dangerouslySetInnerHTML={{ __html: gridItem.data.text }} />
    </Container>
  )
}

export default WebshopTextWidget

const Container = styled(WidgetContainer)`
  p {
    /* Remove the default bottom margin for paragraphs */
    margin: 0;
  }
`
